import { render, staticRenderFns } from "./CutThePriceProductListing.vue?vue&type=template&id=9b328910&"
import script from "./CutThePriceProductListing.vue?vue&type=script&lang=js&"
export * from "./CutThePriceProductListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports